const categories = {
  'cloud-services': 'cloud', 'ai-tools': 'ai', collaboration: 'collaboration', corporate: 'corporate',
  'social-media': 'social', social: 'social', 'social-and-media': 'social',
  'it-security': 'it', smishing: 'smishing', 'servicos-em-nuvem': 'cloud', 'servicios-en-la-nube': 'cloud',
  'ferramentas-de-ia': 'ai', 'herramientas-de-ia': 'ai', colaboracao: 'collaboration', colaboracion: 'collaboration',
  corporativo: 'corporate', 'redes-sociais': 'social', 'redes-sociales': 'social',
  'seguranca-de-ti': 'it', 'seguridad-de-ti': 'it', 'smishing-(sms)': 'smishing'
};
const categorySlug = value => value.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  .replace(/[\s_&]+/g, '-').replace(/-+/g, '-');
const words = { ai: 'AI', it: 'IT', sms: 'SMS', url: 'URL', hr: 'HR', otp: 'OTP', mfa: 'MFA',
  chatgpt: 'ChatGPT', whatsapp: 'WhatsApp', linkedin: 'LinkedIn', onedrive: 'OneDrive', dropbox: 'Dropbox' };

export function readableTemplateName(value = '') {
  return value.replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim().split(' ')
    .map(word => words[word.toLowerCase()] || word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

// The first path segment is a category; the last segment is the title.
// Intermediate directories are source organization, not separate template types.
// Keep the source name and resource IDs intact for imports and pairing.
export function templateOrganization(set, t) {
  const parts = (set.name || '').split('/').map(part => part.trim()).filter(Boolean);
  const sourceParts = (set.source?.originalName || '').split('/').map(part => part.trim()).filter(Boolean);
  const path = parts.length > 1 ? parts : sourceParts;
  const category = set.category && !set.categorySuggested ? set.category
    : path.length > 1 ? path[0] : set.category || '';
  const categoryLabel = category.split('/').filter(Boolean).map(part => {
    const key = categories[categorySlug(part)];
    return key ? t(`template_gallery.category_${key}`) : readableTemplateName(part);
  }).join(' › ') || t('template_gallery.no_category');
  return {
    title: parts.length > 1 ? readableTemplateName(parts[parts.length - 1]) : set.name || t('template_gallery.new_template'),
    category: categoryLabel,
    categoryKey: category ? category.split('/').map(part => categories[categorySlug(part)] || categorySlug(part)).join('/') : ''
  };
}

export function groupTemplateSets(sets, t) {
  const groups = new Map();
  sets.forEach(set => {
    const organization = templateOrganization(set, t);
    const key = organization.categoryKey;
    if (!groups.has(key)) groups.set(key, { key, label: organization.category, sets: [], count: 0 });
    const group = groups.get(key);
    group.sets.push(set);
    group.count += 1;
  });
  return [...groups.values()].sort((a, b) => a.key === b.key ? 0 : !a.key ? 1 : !b.key ? -1 : a.label.localeCompare(b.label));
}

export function matchesTemplateSearch(set, query, t) {
  const organization = templateOrganization(set, t);
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  return normalize([set.name, set.source?.originalName, set.description, organization.title, organization.category].filter(Boolean).join(' '))
    .includes(normalize(query.trim()));
}
